import { readEnvVariable } from '../helpers';

export interface IElevenLabsEnv {
  apiKey: string;
}

export function getElevenLabsEnv(): IElevenLabsEnv {
  return {
    apiKey: readEnvVariable('ELEVENLABS_API_KEY'),
  };
}
